import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RetornoSelecao } from '../../../shared/gridview/RetornoSelecao';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import { environment } from './../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VorService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  // valores para popular o dropdown (/vor/dropdown)
  public motivosDropdown: Array<{ descricao: string, id: number }> = [];
  public andamentosDropdown: Array<{ descricao: string, id: number }> = [];

  @Output() exibir: EventEmitter<RetornoSelecao> = new EventEmitter<RetornoSelecao>();

  constructor(http: HttpClient, router: Router, protected toastr: ToastrService) {
    super(http, router);

    this.baseUrlService = environment.URL_API
  }

  /**
   * Carrega os valores do endpoint `${baseUrlService}/vor/dropdown` e
   * popula `motivosDropdown` para uso em dropdowns.
   */
  public carregarMotivosDropdown(filtros?: any): Promise<any> {
    const url = `${this.baseUrlService}/vor/dropdown`;
    const headers = new HttpHeaders({ 'Authorization': this.getToken(), 'Content-Type': 'application/json; charset=utf-8' });

    return this.getHttpClient().post<any[]>(url, filtros || {}, { headers }).toPromise().then(res => {
      this.motivosDropdown = Array.isArray(res) ? res : [];
      return this.motivosDropdown;
    })
    .catch(error => {
  console.warn('Motivos dropdown não carregado:', error);
  return [];
});
  }
  public carregarAndamentosDropdown(filtros?: any): Promise<any> {
  const url = `${this.baseUrlService}/vor/dropdown-andamento`;
  const headers = new HttpHeaders({
    'Authorization': this.getToken(),
    'Content-Type': 'application/json; charset=utf-8'
  });

  return this.getHttpClient().post<any[]>(url, filtros || {}, { headers }).toPromise().then(res => {
    this.andamentosDropdown = Array.isArray(res) ? res : [];
    return this.andamentosDropdown;
  })
  .catch(error => {
  console.warn('Motivos dropdown não carregado:', error);
  return [];
});
}

  protected getURL(): string {
    return `${this.baseUrlService}/vor`
  }

  tratarErro(mensagem: string, titulo: string, error: any) {
    this.carregando = false;

    console.error(error);

    let texto: string;
    try {
      texto = error.erro ? mensagem + '\n' + error.erro : mensagem;
    } catch (Exception) {
      texto = mensagem;
    }

    this.toastr.error(texto, titulo, error);

    if (error.status === 401) {
      this.router.navigateByUrl('logout');
    }
  }

  public ver(registro: RetornoSelecao) {
    this.carregarModel(registro)
      .then(res => {
        registro = res;
        this.exibir.emit(registro);
      })
      .catch(error => this.tratarErro('Não foi possível carregar o registro.', 'Erro', error));
  }
public atualizarObservacao(dto: any): Promise<any> {
  const url = `${this.baseUrlService}/vor/atualizar_observacao`;
  const headers = new HttpHeaders({
    'Authorization': this.getToken(),
    'Content-Type': 'application/json; charset=utf-8'
  });

  return this.getHttpClient().put<any>(url, dto, { headers }).toPromise()
    .catch(error => {
      this.tratarErro('Não foi possível atualizar a observação.', 'Erro', error);
      throw error;
    });
}
  protected carregarModel(registro: any): Promise<any> {
    return Promise.resolve(registro);
  }

}
